<template>
  <div class="featured_text" :style="cssVars">
    <div class="container">
      <div class="inner" v-html="text" :class="theme"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {},
    text_alignment: {},
    theme: {},
  },

  computed: {
    cssVars() {
      return {
        '--text-alignment': this.text_alignment,
        '--theme': this.theme,
      };
    },
  },

  watch: {},

  methods: {},

  components: {},

  created() {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.featured_text {
  .inner {
    grid-column: span 12;
    padding: 40px 90px;

    @media (max-width: $mobile-xl) {
      grid-column: span 4;
      padding: 40px 30px;
    }

    &::v-deep {
      p,
      li,
      a {
        font-size: 30px;
        line-height: 35px;
        font-weight: 300;
        margin: 0;
      }

      strong {
        font-size: 30px;
        line-height: 35px;
        font-weight: 400;
        margin: 0;
      }

      ul {
        padding-left: 0;
        margin-top: 10px;
        margin-bottom: 0;

        li {
          list-style: none;
          position: relative;
          display: flex;
          align-items: center;
          gap: 15px;
          font: normal normal 300 var(--body-font-size) var(--primary-font-family);

          &::before {
            content: '';
            display: flex;
            width: 5px;
            height: 5px;
            border-radius: 50%;
            background: var(--dark-purple);
          }
        }
      }
    }

    &.green {
      background: var(--green);

      &::v-deep {
        p,
        li,
        a {
          color: var(--dark-purple);
        }

        strong {
          color: var(--dark-purple);
        }
      }
    }

    &.grey {
      background: var(--light-grey);

      &::v-deep {
        p,
        li,
        a {
          color: var(--dark-purple);
        }

        strong {
          color: var(--dark-purple);
        }
      }
    }

    &.purple {
      background: var(--purple);

      &::v-deep {
        p,
        li,
        a {
          color: var(--white);
        }

        strong {
          color: var(--white);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/FeaturedText.vue